export default "/images/vendor/flag-icon-css/flags/1x1/ro.svg?51182fc9671cbaa10989dbae17427f55";